import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import Agb from 'components/Agb'
import CookieConsent from 'components/CookieConsent'
import OrderNews from 'components/OrderNews'
import { UserModulesContextProvider } from 'components/UserModules'
import { selectUserModules } from 'containers/User/selectors'
import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import { ToastContainer } from 'react-toastify'

import { InlineTracking } from '../../components/InlineTracking'
import App from '../App'
import ReturnApp from '../ReturnApp'

// console.log('auftrag root')

let RootEntryPoint = App
let ReturnEntryPoint = ReturnApp

if (global.useReturnEntrypoint) {
  RootEntryPoint = ReturnApp
}

const Root = () => {
  const userModules = useSelector(selectUserModules)

  return (
    <MantineProvider>
      <Notifications position="top-right" />
      <ToastContainer hideProgressBar />
      <CookieConsent />
      <OrderNews />
      <Agb />
      <InlineTracking />
      <UserModulesContextProvider
        value={{
          userModules,
        }}
      >
        <Switch>
          <Route path="/return" component={ReturnEntryPoint} />
          <Route path="/" component={RootEntryPoint} />
        </Switch>
      </UserModulesContextProvider>
    </MantineProvider>
  )
}

export default Root
